import React from 'react';
import { LoadingView } from './styles';

function LoadSpinner({ width = '100%', height = '100%' }) {
  return (
    <LoadingView data-repa='step2-images-loadingView' width={width} height={height}>
      <div className='showbox'>
        <div className='loader'>
          <svg className='circular' viewBox='25 25 50 50'>
            <circle className='path' cx='50' cy='50' r='20' fill='none' strokeWidth='3' strokeMiterlimit='10' />
          </svg>
        </div>
      </div>
    </LoadingView>
  );
}

export default LoadSpinner;
